import { createContext, Dispatch, useContext } from 'react';
import { Action } from '@contexts/Shared';
import { UserState } from '../../domain/models/user-auth.model';
import { UserStatus } from '../../domain/models/user-status.model';

export type UserContextState = UserState & { dispatch: Dispatch<Action> };

export function createInitialUserState(): UserState {
  return {
    status: UserStatus.VALIDATING_LOGIN,
    data: undefined,
    token:
      (typeof window !== 'undefined' && localStorage.getItem('token')) ||
      undefined,
  };
}

export const UserInitialState: UserState = {
  status: UserStatus.VALIDATING_LOGIN,
  data: undefined,
  token:
    (typeof window !== 'undefined' && localStorage.getItem('token')) ||
    undefined,
};

export const isLoggedIn = (state: UserContextState): boolean =>
  state.status === UserStatus.IS_LOGGED_IN;
export const UserContext = createContext<UserContextState | null>(null);
export const useLoggedInUser = () => useContext(UserContext);
